import { render, staticRenderFns } from "./DisciplineConfig.vue?vue&type=template&id=cf04e3c8&scoped=true&"
import script from "./DisciplineConfig.vue?vue&type=script&lang=js&"
export * from "./DisciplineConfig.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineConfig.vue?vue&type=style&index=0&id=cf04e3c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf04e3c8",
  null
  
)

export default component.exports